import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M23_TOPICS, M23_MODULE_INFO } from '../data/mathExercises/M23_CrossTopic';

const M23CrossTopicExercise = ({ onProgress }) => {
  // Create some sample cross-topic problems
  const sampleProblems = [
    {
      id: 'M23_01_P001',
      topicId: 'M23_01',
      question: "在坐標平面上，已知拋物線 y = x² - 4x + 3 與直線 y = 2x - 1 相交於兩點，求交點坐標",
      solution: "交點為 (1, 1) 和 (4, 7)",
      explanation: "結合二次函數和一次函數的交點問題",
      difficulty: 2,
      order: 1,
      steps: ["聯立方程：x² - 4x + 3 = 2x - 1", "整理：x² - 6x + 4 = 0", "解得：x = 3 ± √5", "代入求 y 坐標"]
    },
    {
      id: 'M23_02_P001',
      topicId: 'M23_02',
      question: "已知函數 f(x) = 2x + 1，g(x) = x² - 3，求複合函數 f(g(x)) 和 g(f(x))",
      solution: "f(g(x)) = 2x² - 5, g(f(x)) = 4x² + 4x - 2",
      explanation: "函數複合的計算",
      difficulty: 2,
      order: 1,
      steps: ["f(g(x)) = f(x² - 3) = 2(x² - 3) + 1 = 2x² - 5", "g(f(x)) = g(2x + 1) = (2x + 1)² - 3 = 4x² + 4x - 2"]
    }
  ];
  
  return (
    <ExerciseInterface
      moduleInfo={M23_MODULE_INFO}
      topics={M23_TOPICS}
      problems={sampleProblems}
      onProgress={onProgress}
      className="m23-exercise"
    />
  );
};

export default M23CrossTopicExercise; 